// extracted by mini-css-extract-plugin
export default {"appWrapper":"_3Ci9n","appContent":"_2cxmD","main":"_1ByvU","mobileSwitcher":"_15sts","disableBodyScroll":"_3mlBT","disableBodyScrollOnPreviewPage":"rWa4-"};